import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from 'components/Button';
import './style.scss';

export default class MenuItem extends Component {
  static propTypes = {
    label: PropTypes.string,
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    index: PropTypes.number,
    order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onReorder: PropTypes.func.isRequired,
  };

  static defaultProps = {
    label: '',
    isActive: false,
    isDisabled: false,
  };

  handleReorder = () => {
    this.props.onReorder(this.props.order, this.props.index);
  };

  render() {
    const { label, isActive, isDisabled, order } = this.props;
    return (
      <Button
        isText
        styleName={cn('item', { 'is-active': isActive })}
        disabled={isDisabled}
        onClick={this.handleReorder}
        data-test="menu-item-button"
      >
        {label || order}
      </Button>
    );
  }
}
